<button class="btn btn-sm btn-link"
        [attr.data-identifier]="dataIdentifierPrefix + '-viewhistory'"
        (click)="displayHistory=true">View History
    <i class="fa fa-history"></i>
</button>
<p-dialog header="History" [modal]="true" [(visible)]="displayHistory" [style]="{ width: '55rem' }">
    <ng-container *ngIf="displayHistory">
        <lib-audit-log-filter [enterpriseId]="enterpriseId"
                              [enterpriseLabels]="enterpriseLabels"
                              [eventCategory]="eventCategory"
                              [dataIdentifierPrefix]="dataIdentifierPrefix"
                              (auditLogFilterChange)="handleFilterChange($event)"></lib-audit-log-filter>
        <lib-audit-log-table [enterpriseId]="enterpriseId"
                             [enterpriseLabels]="enterpriseLabels"
                             [eventCategory]="eventCategory"
                             [dataIdentifierPrefix]="dataIdentifierPrefix"
                             [auditLogFilterObs]="auditLogFilterSubject"></lib-audit-log-table>
    </ng-container>
    <div class="row">
        <div class="btn-done col-md-4">
            <button class="btn btn-primary"
                    [attr.data-identifier]="dataIdentifierPrefix + '-done'"
                    (click)="displayHistory=false">Done
            </button>
        </div>
    </div>
</p-dialog>
